import React from "react";import { HomeInfo } from "../models/system";
;
export class Virtual extends React.Component<HomeInfo>{
    render(){
     
        return(
                
            <div className="virtual">
                        
            <div className="virtual_va"></div>
            <div className="virtual_vb"></div>
            <div className="virtual_vc"></div>
            <div className="virtual_vd"></div>
            <div className="virtual_ve"></div>
            </div>
        )
    }
}